// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".row{margin-bottom:0}.row,.row+.row{margin-top:0}.cart-action-dialog{background:#fff;padding:32px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
